import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { useNavigation } from '@refinedev/core';
import { Form, Input, message } from 'antd';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'defaultText', translationKey: 'text', label: 'Text', placeholder: 'Cancel', required: true },
];

export const AppStringCreate: React.FC = () => {
  const { formProps, onFinish } = useForm({ resource: 'app-strings' });
  const { push } = useNavigation();

  const handleSubmit = async (values: any) => {
    try {
      await onFinish({
        ...values,
        translations: normalizeTranslations(values.translations, LANG_FIELDS),
      });
      message.success('App string created');
      push('/app-strings');
    } catch (err: any) {
      message.error(err?.message || 'Failed to create app string');
    }
  };

  return (
    <Create
      resource="app-strings"
      saveButtonProps={{ onClick: () => formProps.form?.submit() }}
    >
      <Form {...formProps} layout="vertical" onFinish={handleSubmit}>
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Key" name="key" rules={[{ required: true }]}>
          <Input placeholder="common.cancel" />
        </Form.Item>
        <Form.Item label="Namespace" name="namespace" rules={[{ required: true }]}>
          <Input placeholder="common" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={2} />
        </Form.Item>
      </Form>
    </Create>
  );
};
